<template>
  <span class="whitespace-nowrap">
    <span> {{ $t('price.shipping_cost_hint.plus') }}&nbsp; </span>
    <span>{{ $t('price.shipping_cost_hint.shipping_cost') }}</span>
  </span>
</template>

<script lang="ts">
export default defineComponent({
  name: 'ShippingCostHint',
})
</script>
